module.exports = {
  message: {
    high_loan: 'Khoản vay tối đa hiện tại của bạn',
    home: 'Trang chủ',
    loginIn: 'Đăng nhập',
    loginOut: 'Đăng xuất',
    immit_loan_quickly: 'Đăng ký vay ngay',
    get_menoy: 'Nhận tiền',
    info_cjwt: 'Vấn đề thường gặp',
    info_dkzf: 'Thanh toán khoản vay',
    info_lxwm: 'Liên hệ chúng tôi',
    zc_and_sk: 'Đăng ký và nhận tiền',
    loan_mount: 'Số tiền vay',
    loan: 'Khoản Vay',
    loan_limit: 'Thời hạn vay',
    date: 'ngày',
    name: 'Họ và tên',
    tel_id: 'Số điện thoại',
    code: 'Mật khẩu',
    apply_loan: 'Nộp đơn vay',
    cx_simple: 'Thủ tục đơn giản',
    no_dy: 'Không cần thế chấp',
    xq_simple: 'Quá trình gia hạn dễ dàng',
    pay_simple: 'Phương thức thanh toán dễ dàng',
    day_income: 'Nhận tiền trong ngày',
    loan_high_money: 'Hạn mức vay cao',
    why_choose: 'Tại sao nên chọn chúng tôi',
    loan_5_min: 'Nộp đơn vay trong 5 phút',
    loan_jl: 'Ưu đãi cho các khoản vay tiếp theo',
    simple: 'Thuận tiện',
    everywhere: 'Mọi lúc, mọi nơi',
    weiWang: 'Uy tín',
    keepScript: 'Giữ bí mật tuyệt đối thông tin của bạn',
    deal_loan: 'Giải pháp tài chính hiện đại',
    run_qg: 'Quá trình đăng ký hoàn toàn trực tuyến',
    online_zc: 'Quá trình đăng ký hoàn toàn trực tuyến',
    simple_3_step: 'Nhận được tiền sau 3 thao tác đơn giản',
    input_per_info: 'Điền thông tin cá nhân',
    contact_U: 'Sẽ liên lạc với bạn',
    loan_quickly: 'Vay nhanh',
    simple_2_loan: 'Vay tiền dễ dàng, được phê duyệt trong vòng 2 giờ',
    jd_search: 'Kiểm tra tiến độ',
    history_bill: 'Lịch sử thanh toán',
    repay_now: 'Trả nợ ngay lập tức',
    edit_news: 'Chỉnh sửa thông tin',
    no_bill: 'Bạn không có đơn xin vay ',
    submit_bill_succ: 'Nộp đơn thành công',
    deal_u_bill: 'Đơn hàng của bạn đang được xử lý',
    cl_bill: 'Đang xử lý đơn hàng',
    out_jg: 'Kết quả thẩm định dự kiến có trong vòng 24 giờ',
    tg_wait_loan: 'Phê duyệt thông qua, chờ giải ngân',
    work_2_loan: '2 ngày nữa sẽ tới hạn thanh toán',
    loan_success: 'Vay thành công',
    serch_account: 'Vui lòng kiểm tra tài khoản của bạn',
    orderId: 'Mã số đơn',
    loan_amout: 'Số tiền vay',
    qs: 'Số kỳ',
    repay_time: 'Ngày phải thanh toán',
    apply_status: 'Tình trạng đơn đăng kí',
    see_detail: 'Xem chi tiết',
    shz: 'Đang xem xét',
    sh_refuse: 'Đơn đăng kí bị từ chối',
    sh_tg: 'Đã phê duyệt',
    cancle: 'Đã hủy',
    yh_manger: 'Phí quản lý người dùng',
    apply_quick_loan: 'Phí nộp đơn nhanh',
    interest: 'Lãi suất',
    Overdue_fj: 'Tiển phạt quá hạn ',
    apply_date: 'Ngày nộp đơn',
    bill_detail: 'Chi tiết thanh toán',
    com_repay: 'Xác nhận trả nợ',
    basc_info: 'Thông tin cơ bản',
    bank_amount: 'Tài khoản ngân hàng',
    login_code: 'Mật khẩu đăng nhập',
    no_edit_pasd: 'Bạn tạm thời không thể sửa đổi thông tin',
    add_bank: 'Thêm tài khoản ngân hàng',
    default: 'Mặc định',
    com_edit_bank: 'Xác nhận sửa đổi tài khoản ngân hàng này làm tài khoản ngân hàng mặc định không?',
    yhy: 'Đã xác minh',
    hy_w: 'Chưa được xác minh',
    hy_error: 'Xác minh thất bại',
    edit_bank: 'Sửa đổi tài khoản ngân hàng ',
    infos_rz_bank: 'Tài khoản ngân hàng của bạn chưa được xác thực, vui lòng xác minh trước',
    set_success: 'Thiết lập thành công',
    bank_no_set_deauflt: 'Tài khoản này không hỗ trợ cài đặt tài khoản ngân hàng mặc định',
    delete_success: 'Đã xóa thành công',
    no_delete_1bank: 'Chỉ có thể liên kết 1 tài khoản ngân hàng, không hỗ trợ liên kết thêm',
    ipt_psd: 'Nhập mật khẩu mới',
    ipt_psd_again: 'Nhập lại mật khẩu mới',
    js_edit_psd: '* Lưu ý: Vui lòng thay đổi mật khẩu cẩn thận!',
    edit_psd: 'Thay đổi mật khẩu',
    del: 'Xóa',
    ts: 'Gợi ý',
    reback: 'Quay lại',

    psd_login: 'Mật khẩu đăng nhập',
    code_login: 'Mã xác minh đăng nhập',
    send_code: 'Gửi mã xác minh',
    IDcardZM: 'Phía trước CMND/CMT',
    IDcardFM: 'Phía sau CMND/CMT',
    hold_ID: 'Chụp ảnh bạn tay cầm chứng minh thư',
    work_photo: 'Chứng minh công việc',
    jx: 'Tiếp tục',
    img_upload_agagin: 'Hình ảnh tải lên không thành công , vui lòng tải lại',
    img_upload_success: 'Hình ảnh được tải lên thành công',
    upLoad_image_no: 'Hình ảnh của bạn chưa tải lên , vui lòng tải hình ảnh lên trước',
    Parameter_error: 'Lỗi tham số',

    gender: 'giới tính',
    fullName: 'Họ và tên',
    ID: 'Chứng minh nhân dân',
    age: 'Ngày sinh',
    education: 'Học vấn',
    marriage: 'Hôn nhân',
    income: 'Thu nhập',
    Career: 'Nghề nghiệp',
    Companyphone: 'Điện thoại công ty',
    compay: 'Tên công ty',
    adress: 'Địa chỉ',
    city: 'Thành phố',
    get_fb_link: 'Huong dan lay link Facebook',
    cancel: 'Hủy bỏ',
    determine: 'Xác định',

    basc_post_success: 'Thông tin cơ bản được gửi thành công',
    jcNEWS: 'Vui lòng kiểm tra thông tin có đầy đủ  không',

    xl_gzyx: 'Phổ thông',
    xl_gz_zz: 'Trung cấp',
    xl_dz: 'Đại học',
    xl_bk: 'Thạc sĩ',

    hy_wh: 'Chưa kết hôn',
    hy_yh: 'Đã kết hôn',
    hy_ly: 'Ly hôn',
    hy_so: 'Góa vợ/chồng',

    sr_3jyx: 'Dưới 3 triệu',
    sr_3d6: '3 triệu~6 triệu',
    sr_6d9: '6 triệu~9 triệu',
    sr_9d12: '9 triệu~12 triệu',
    sr_1ys: '12 triệu trở lên',

    gx_fq: 'Cha',
    gx_mq: 'Mẹ',
    gx_po: 'Vợ chồng',
    gx_zn: 'Con',
    gx_qtqs: 'Họ hàng khác',
    gx_py: 'Bạn bè',
    gx_ts: 'Đồng nghiệp',
    gx_qt: 'Khác',

    zy_js: 'Giáo viên',
    zy_fuy: 'Nhân viên phục vụ',
    zy_sj: 'Tài xế',
    zy_wy: 'Nhân viên văn phòng',
    zy_kf: 'Chăm sóc khách hàng',
    zy_xsy: 'Nhân viên bán hàng',
    zy_yj: 'Bưu tá',
    zy_ys: 'Bác sĩ',
    zy_jishi: 'Kĩ sư',
    zy_fy: 'Phiên dịch',
    zy_ls: 'Luật sư',


    zy_kj: 'Kế toán',
    zy_zj: 'Tư vấn viên / môi giới',
    zy_tx: 'Nghĩ hưu',
    zy_xs: 'Học sinh',
    zy_jy: 'Hộ kinh doanh',
    zy_jc: 'Cảnh sát / quân nhân',
    zy_nm: 'Nông dân / ngư dân',
    zy_bw: 'Bảo vệ',
    zy_yg: 'Công nhân',
    zy_jw: 'Nội trợ',
    zy_jz: 'Làm thời vụ',
    zy_qt: 'Khác',

    contct: 'Người liên hệ',
    phone: 'Số điện thoại',
    relation: 'Mối quan hệ',
    social_info: 'Thông tin xã hội',
    repay_style: 'Phương thức trả nợ',
    repay_hklx: 'Loại hình trả nợ',


    holdName: 'Tên chủ thẻ',
    idcar: 'Số ID',
    bankCard: 'Số tài khoản ngân hàng',
    bankNwes: 'Thông tin ngân hàng',
    borrowImmediate: 'Vay ngay lập tức',
    jiancha: 'Vui lòng kiểm tra thông tin tài khoản ngân hàng của bạn',
    banks_binded: 'Thẻ ngân hàng đã được liên kết, vui lòng thay đổi thẻ khác để liên kết lại',
    add_com: 'Xác nhận thêm',
    add_success: 'Thêm thành công',

    order_cancel: 'Hủy đơn hàng',
    order_shcg: 'Duyệt đơn thành công',
    order_shjj: 'Đơn bị từ chối',
    order_wait: 'Chờ giải ngân',
    order_loan_success: 'Giải ngân thành công',
    order_refuse: 'Từ chối giải ngân',
    order_fkz: 'Đang giải ngân',
    all: 'Tất cả',
    dai_wac: 'Đang chờ hoàn trả',
    bill_iwc: 'Đã hoàn thành',
    bill_repay_status: 'Trạng thái thanh toán',
    bill_whk: 'Chưa thanh toán',
    bill_tchk: 'Trễ hạn',
    bill_whq: 'Chưa trả hết',
    bill_sq_status: 'Trạng thái xin vay',
    bill_yhk: 'Trả nợ',
    bill_jkqx: 'Thời hạn cho vay',
    edit_grxx: 'Sửa đổi thông tin cá nhân',
    edit_tips: '* Lưu ý: Thông tin này liên quan trực tiếp đến khả năng vay của bạn, vui lòng điền vào đúng sự thật !',
    edit_com: 'Xác nhận sửa đổi',
    edit_success: 'Sửa đổi thành công',
    edit_error: 'Chỉnh sửa thất bại',
    error_code: 'Sai mật khẩu',
    borrow_lijk: 'Vay ngay',
    borrow_wbdyhk: 'Chưa liên kết tài khoản ngân hàng ',
    borrow_bfhtj: 'Không đủ điều kiện',
    borrow_uncomplete: 'Có đơn hàng chưa hoàn thành',
    borrow_sfbq: 'Thông tin CCCD không đầy đủ',
    borrow_nlbg: 'Chưa đủ tuổi',
    borrow_rzxxbq: 'Thông tin chứng nhận không đầy đủ',
    borrow_system: 'Bảo trì hệ thống',
    borrow_choose_bank: 'Vui lòng chọn đúng tài khoản ngân hàng',
    borrow_bfhdktj: 'Không đủ điều kiện để vay',
    pay_total: 'Số tiền thanh toán',
    add_bank_tips: '* Lưu ý: Các khoản vay sẽ được hệ thống gửi trực tiếp vào thẻ ngân hàng của bạn, vui lòng đảm bảo điền đúng thông tin thẻ ngân hàng, nếu không bạn có thể sẽ không nhận được khoản vay!',
    repay_skdw: 'Đơn vị nhận tiền',
    repay_bank_news: 'Thông tin ngân hàng',
    repay_zh_bank: 'Tên chi nhánh ngân hàng',
    repay_zh: 'Tài khoản ngân hàng',
    repay_next_date: 'Thời gian trả nợ tiếp theo',
    repay_map_new: 'Thông tin bản đồ',
    repay_server_money: 'Phí dịch vụ',
    repay_code: 'Mã giao dịch',
    repay_bld: 'Địa chỉ cửa hàng tiện lợi',
    repay_hm: 'Tên tài khoản',
    repay_zh1: 'Tài khoản',
    repay_bank: 'Ngân hàng',
    repay_money: 'Số tiền hoàn trả',
    repay_tq_tips: '* Lưu ý: Trả nợ sớm không làm giảm lãi!',
    order_no_message: 'Bạn không có đơn hàng chờ trả nợ ！',

    banksAccount: 'Số tài khoản ngân hàng',
    xians: 'Trả nợ qua ngân hàng',
    xianxia: 'Trả nợ qua cửa hàng',
    quank: 'Thanh toán đầy đủ',
    xuq: 'Gia hạn',
    enterPhone: 'Nhập số điện thoại',
    ver_code: 'Mã xác minh',
    ver_code_success: 'Mã xác minh được gửi thành công',
    ver_code_error: 'Gửi mã xác minh thất bại',
    login_success: 'Đăng nhập thành công',
    login_error: 'Đăng nhập thất bại',
    index_ts: 'vay dễ dàng,  xét duyệt trong 3 giờ đồng hồ',
    pasenoLOAD: 'Bạn tạm thời không thể vay',
    index_rzxx: 'Xác nhận thông tin',
    ipt_correct_id: 'Vui lòng nhập đúng số CCCD',
    fb_error: 'định dạng facebook không chính xác',
    sub_new_error: 'Gửi thông tin thất bại',
    ipt_has_uIpt: 'Bạn có nội dung bị thiếu',

    trait_1: 'Khoản vay từ',
    trait_1_1: '1-5 triệu VNĐ',
    trait_2: 'Nhận tiền',
    trait_2_1: 'trong ngày',
    trait_3: 'Thanh toán',
    trait_3_1: 'dễ dàng',
    trait_4: 'Không yêu cầu',
    trait_4_1: 'Thế chấp',
    trait_5: 'Thủ tục gia hạn',
    trait_5_1: 'đơn giản',
    step1: 'Tải ảnh lên',
    step2: 'Điền thông tin cơ bản',
    yjh_loan: 'có cơ hội vay',
    sel_ipt: 'Điền chọn',
    sel_ipt1: '(Điền chọn)',
    must_ipt:'Bắt buộc điền',
    upload_scz: 'Đang tải lên...',
    upload_scz_error: 'Tải lên thất bại',
    zc: 'Đăng ký',
    info_lxwm_time: 'Thời gian làm việc : Thứ hai – Thứ bảy : 08:00-17:00',
    info_lxwm_server: 'Trung tâm chăm sóc khách hàng:',
    info_dkzf_step1: 'Đến chi nhánh ngân hàng gần nhất hoặc tạo giao dịch tại cửa hàng tiện lợi gần đó',
    info_dkzf_step2: 'Trả hết tiền vay và giữ biên lai chuyển tiền',
    info_cjwt_ybzx: 'Thông tin chung',
    info_cjwt_Q1: ' Để được vay có những điều kiện gì?',
    info_cjwt_Q2: ' Tôi cần cung cấp những giấy tờ gì để được vay?',
    info_cjwt_Q3: 'Công ty của bạn cho vay ở khu vực và tỉnh nào?',
    info_cjwt_Q4: 'Tôi đã điền xong đơn đăng ký . Tôi cần làm gì tiếp theo?',
    info_cjwt_a1: 'Để được vay, bạn phải là công dân của quốc gia ,bạn trong độ tuổi từ 18 đến 50 và có giấy tờ tùy thân hợp lệ',
    info_cjwt_a2: 'Bạn chỉ cần cung cấp thông tin cá nhân của mình để đủ điều kiện',
    info_cjwt_a3: 'Chúng tôi cung cấp dịch vụ trên tất cả các tỉnh thành',
    info_cjwt_a4: 'Khi đơn đăng ký của bạn được phê duyệt , bạn sẽ nhận được tin nhắn thông báo , và bạn sẽ nhận được khoản vay trong vòng hai giờ kể từ khi được ký duyệt',
    info_cjwt_hddk: 'Nhận khoản vay',
    info_cjwt_hddk_Q1: 'Tôi nên làm gì nếu tôi chưa nhận được khoản vay trong vòng 2 giờ?',
    info_cjwt_hddk_a1: 'Sau 2 giờ, nếu bạn chưa nhận được khoản vay, vui lòng liên hệ với chúng tôi qua đường dây nóng: ',
    info_cjwt_dkzf: 'Thanh toán khoản vay',
    info_cjwt_dkzf_Q1: 'Tôi có thể trả nợ trước hạn không?',
    info_cjwt_dkzf_a1: 'Được, bạn có thể trả hết khoản vay trước ngày đáo hạn.',
    info_cjwt_dkzf_Q2: 'Điều gì xảy ra nếu tôi trả hết khoản vay sau ngày đáo hạn ?',
    info_cjwt_dkzf_a2: 'Để thuận tiện, bạn nên hoàn trả khoản vay vào ngày đáo hạn. Nếu bạn trì hoãn thanh toán, bạn sẽ bị tính phí trễ.',

    deal_photo_cj: 'Cắt hình',
    deal_photo_xz: 'Xoay hình ảnh',
    deal_photo_tjtp: 'Gửi hình ảnh',
    deal_photo_cz: 'Nhắc nhở',
    deal_photo_text: 'Vui lòng điều chỉnh kích thước cắt khung màu như trong hình ảnh mẫu. Sau khi điều chỉnh, hãy nhấp vào nút cắt, sau đó nhấp vào nút gửi hình ảnh',
    deal_photo_sl: 'Thí dụ',

    ipt_old_psd: 'Mật khẩu cũ',

    verity_code: 'Xin vui lòng nhập mật khẩu',
    verity_iphone: 'Vui lòng nhập số điện thoại chính xác',
    loan_data: 'Thời gian cho vay ',
    rixi_fei: 'Phí lãi ngày',
    yuqi_fei: 'Phí lãi quá hạn',
    cs_mima: 'Mật khẩu đăng nhập mặc định là sáu số cuối của số điện thoại di động khi đăng ký',


    btn_info_41: 'Đang xem xét đơn hàng',
    btn_info_44: 'Từ chối duyệt',

    btn_info_30: 'Đang chờ giải ngân',
    btn_info_1: 'Bạn có một đơn đặt hàng',
    btn_info_2: 'Đơn cùa bạn đã quá hạn',
    btn_info_31: 'Kế toán từ chối',

    loan_dz: 'Số tiền nhận',
    loan_dq: 'Thời gian đến hạn',

    message_ipt_code: 'Vui lòng nhập mã xác nhận',
    repay_beizhu: 'Ghi chú',

    yys_rz: 'Chứng nhận nhà mạng',
    yys_code_success: 'Mã xác minh được gửi thành công, vui lòng nhập mã xác minh',
    yys_code_error_click: 'Mã xác minh được gửi không thành công, vui lòng nhấp lại',
    yys_code_inpt_again: 'Vui lòng nhập lại mã xác minh mới',
    yys_error_code: 'Mã xác minh không chính xác, vui lòng nhập lại',
    yys_sub: 'Gửi',
    yys_tel: 'Số điện thoại',
    yys_code: 'Mã xác minh',
    yys_sub_success: 'Gửi thành công',

    th_yys_sjh: 'Số điện thoại',
    th_yys_yzm: 'Mã xác thực',
    th_yys_qsryzm: 'Nhập mã xác thực',
    th_yys_sfz: 'CMT/CCCD',
    th_yys_qsrsfz: 'Nhập CMT/CCCD',
    th_yys_fhsyy: 'Trang trước',
    th_yys_yysmm: 'Mã nhà mạng',
    th_yys_qsryysmm: 'Nhập mã nhà mạng',
    th_yys_qjxrzsfz: 'Tiếp tục xác thực CMT/CCCD',
    th_yys_hqyzm: 'Lấy mã xác thực',
    th_yys_qx: 'Quyền hạn',
    th_yys_rzcg: 'Xác thực thành công',

// 一下是新添加的
    basc_photo: 'Nộp chứng từ',
    yys_tg: 'Bỏ qua',
    index_shcg: 'Xét duyệt thông qua',
    index_dws: 'Chờ hoàn thiện',
    index_jdcx: 'Xem tiến độ',
    index_sqdd: 'Nộp đơn',
    index_grzx: 'Thông tin khách hàng',
    index_rz_tips: 'Bạn còn thông tin chưa xác nhận, hãy xác nhận',
    sch_shz: 'Đang xét duyệt',
    sch_dtx: 'Chờ giải ngân',
    sch_dhk: 'Chờ thanh toán',
    sch_ywc: 'Hoàn thành',
    sch_ckjd: 'Kiểm tra tiến độ',
    sch_ytg: 'Đã thông qua',
    sch_tx: 'Giải ngân',
    sch_txz: 'Đang giải ngân',
    sch_yfk: 'Đã giải ngân',
    sch_hk: 'Thanh toán',
    sch_yjj: 'Bị từ chối',
    sch_cxjk: 'Đăng ký vay lại',
    with_txjw: 'Số tiền giải ngân',
    with_tx_tips: 'Ngày giải ngân là ngày bắt đầu tính khoản vay',
    with_tx_ddxx: 'Quản lý đơn hàng',
    with_tx_jkr: 'Người vay',
    with_tx_jkts: 'Kỳ hạn vay',
    with_tx_jkje: 'Hạn mức vay',
    with_tx_dzje: 'Số tiền thực nhận',
    with_tx_yhje: 'Số tiền phải thanh toán',
    with_tx_skyh: 'Ngân hàng nhận',
    with_tx_skzh: 'Tài khoản nhận tiền',
    with_tx_ljtx: 'Giải ngân ngay',
    view_sc_sqje: 'Hạn mức đăng ký',
    view_sc_jkmx: 'Thông tin khoản vay',
    view_sc_sqsj: 'Thời gian đăng ký',
    view_sc_sx: 'Tải lại',
    repay_jlhk: 'ngày đến hạn thanh toán',
    repay_nyyq: 'Đã quá hạn',
    repay_hkr: 'Ngày đến hạn thanh toán',
    repay_qjkhk: 'Hãy thanh toán ngay',
    repay_yqf: 'Phí phạt quá hạn',
    repay_yhze: 'Số tiền phải thanh toán',
    borrow_dksq: 'Đăng ký vay',
    borrow_nmqzg: 'Hạn mức cao nhất',
    my_title: 'Thông tin khách hàng',
    my_yhzhgl: 'Quản lý tài khoản ngân hàng',
    my_zxkf: 'Liên hệ CSKH',
    my_logout: 'Đăng xuất',
    ser_qxzkf: 'Hãy chọn liên hệ CSKH',
    ser_gfgh: 'Hotline',
    ser_nkydj: 'Ấn trực tiếp vào số điện thoại bên dưới để gọi',
    ser_zalo: 'Tài khoản Zalo của chúng tôi',
    ser_addZalo: 'Bạn có thể liên hệ với chúng tôi qua số zalo dưới đây',
// th_yys_qsryzm:'vui lòng nhập mã xác nhận'

    /**新版sass新添加的***/
    service_timeout: 'Yêu cầu đã hết thời gian chờ, hãy làm  mới và thử lại',

    for_pass: 'Quên mật khẩu, Thử đăng nhập bằng SMS',

    use_phone: 'Để mang đến cho bạn trải nghiệm dịch vụ tốt hơn, vui lòng sử dụng điện thoại di động của bạn để đăng nhập vào trang web',

    choose_banks: 'Vui lòng chọn ngân hàng',

    bind_bank_account: 'Bạn chưa liên kết tài khoản ngân hàng được sử dụng cho tài khoản',

    home_my: 'Của tôi',
    other_gj: 'Công cụ khác',
    loan_record: 'Lịch sử khoản vay',
    sch_sh: 'Thẩm định',
    yys_tip: 'Hệ thống sẽ lấy thông tin cá nhân của bạn thông qua nhà điều hành điện thoại di động',

    choose_yys: 'Vui lòng chọn Nhà điều hành của điện thoại',

    rz_intro: 'Mô tả xác thực',
    rz_intro1: 'Để xác minh số điện thoại di động, cần nhà mạng xác minh tên thật để xác thực số điện thoại',

    rz_intro2: 'Mã xác thực phải giống với số đăng ký',

    rz_intro3: 'Nếu bạn quên mật khẩu dịch vụ, bạn có thể gọi cho nhà mạng để cài đặt',

    start_rz: 'Bắt đầu xác thực',
    gxntjcg: 'Chúc mừng bạn đã gửi thành công',

    fksjts: 'Vay trong ngày xét duyệt ngay trong ngày',
    bank_rz: 'Xác thực thẻ ngân hàng',//越南改为了添加银行卡
    bank_rz_tips: 'Thêm thẻ ngân hàng, điền đúng tài khoản ngân hàng, thông tin ngân hàng và thông tin cá nhân phải thống nhất thì bạn sẽ nhanh chóng có được khoản vay',

    basc_info_rz: 'Xác nhận thông tin cơ bản',
    basc_info_rz_tips: 'Thông tin dưới đây chỉ được sử dụng để xem xét số tiền vay, và chúng tôi sẽ bảo mật thông tin của bạn theo quy định của pháp luật',

    ipt_u_xm: 'Vui lòng nhập tên của bạn',
    ipt_u_bir: 'Hãy chọn ngày tháng năm sinh',
    ipt_u_edu: 'Hãy chọn trịnh độ giáo dục',
    ipt_u_marr: 'Hãy chọn tình trạng hôn nhân',
    ipt_u_income: 'Hãy chọn thu nhập',
    photo_rz: 'Xác thực danh tính',
    photo_rz_tip: 'Vui lòng tải lên ảnh nhận dạng, chỉ để xác minh danh tính',

    psyq: 'Yêu cầu về chụp chứng minh nhân dân',
    psyq_sfz: 'Đảm bảo chứng minh thư khi chụp',
    psyq_sfz_bk: 'Khung hình hoàn chỉnh, phông chữ rõ ràng, độ sáng đồng đều',

    bz: 'Tiêu chuẩn',
    bkqs: 'Thiếu đường viền',
    zpmh: 'Hình ảnh mờ',
    sgql: 'Đèn flash mạnh',
    social_rz: 'Xác thực xã hội',
    social_rz_tips: 'Thông tin dưới đây chỉ sử dụng cho xét duyệt hạn mức khoản vay, chúng tôi có thể liên hệ với người thân của bạn và cam kết bảo mật thông tin của bạn theo quy định của pháp luật.',

    social_rz_tips2: 'Trong quá trình xét duyệt, chúng tôi sẽ sử dụng thông tin trên để tham khảo. Vui lòng điền đầy đủ thông tin để đảm bảo rằng bạn nhận được số tiền vay',

    repay_yq: 'Quá hạn',
    repay_yq1: 'Vui lòng trả nợ đúng hạn, để không ảnh hưởng đến tín dụng của bạn',

    repay_yq2: 'Quý khách đã quá hạn thanh toán, vui lòng thanh toán đúng hạn',

    male: 'Nam',
    Female: 'Nữ',
    tel_psd_rz: 'Số điện thoại hoặc mật khẩu không được để trống',
    qxz_sty: 'Vui lòng chọn',
    yys_reset_wjmm: 'Quên mật khẩu ',
    bank_yhmc: 'Tên ngân hàng',
    repay_skzh: 'Tài khoản nhận tiền',
    tian: 'Ngày',
    edit_cs_psd: 'Mật khẩu đăng nhập ban đầu của khách hàng mới là 1111111,  Vì sự an toàn của tài khoản của bạn, vui lòng sửa đổi mật khẩu đăng nhập ngay sau khi đăng ký !!!',
    index_jdlc: 'Quy trình cho vay đơn giản và an toàn',
    index_syxq: 'Kết nối mọi nhu cầu vay của bạn',
    index_ksjklc: 'Quy trình vay nhanh chóng',
    index_pro: 'Các sản phẩm cho vay của chúng tôi',
    index_ty: 'Mang lại cho bạn trải nghiệm tốt khi có nhu cầu vay tiền',

    index_jd: 'Có nhiều hình thức vay, vay online linh hoạt, thao tác thanh toán đơn giản',

    index_tips: 'Để mang đến cho bạn trải nghiệm tốt hơn, chúng tôi đã thiết kế ứng dụng rất đơn giản để giúp bạn dễ dàng xác minh thông tin. Đơn đã gửi của bạn sẽ được xem xét ngay lập tức và thanh toán nhanh chóng. Bạn có thể theo dõi trạng thái thẩm định đơn đăng ký và tiến hành thanh toán khoản vay bất cứ lúc nào ',

    loan_need: 'Bạn cần vay bao nhiêu',
    loan_ed: 'Hạn mức khoản vay',
    we_solve: 'Chúng tôi giải quyết những gì',
    all_ans: 'Tất cả nghi vấn khoản vay',
    ybxx: 'Điền thông tin',
    ybxx_a: 'Phải là công dân của nước sở tại với giấy tờ tùy thân hợp lệ',

    dk: 'Đăng ký khoản vay',
    dk_a: 'Nếu sau 2 giờ bạn vẫn chưa nhận được khoản vay, vui lòng liên hệ với chúng tôi qua hotline',
    dkzf: 'Thanh toán khoản vay',
    dkzf_a: 'Có thể trả trước hạn, thanh toán trước ngày đáo hạn',

    why_c: 'Lý do bạn nên chọn chúng tôi',
    why_lh: 'Khoản vay linh hoạt và nhanh chóng',
    why_1: 'Tất cả các khoản vay đều có lãi suất rất thấp',

    why_2: '99.9% khách hàng đã vay thành công',
    why_3: 'Giúp bạn linh hoạt trong việc trả nợ',
    why_apply: 'Quy trình đăng ký nhanh chóng và dễ dàng',
    why_4: 'Điền thông tin của bạn',
    why_5: 'Đăng ký khoản vay',
    why_6: 'Nhận khoản vay',
    jd: 'Đơn giản',
    tm: 'Rõ ràng',
    aq: 'an toàn',
    get_quck: 'Nhận khoản vay của bạn một cách nhanh chóng',
    rz_succ: 'Xác nhận hoàn tất',
    first_rz:'Thông tin cơ bản',
    voice_code:'Không thể nhận SMS? Hãy thử mã xác minh bằng giọng nói',
    otp_message:'Mã xác minh SMS',

    gg_detail:'Chi tiết thông báo',
    mar_tip:'Lưu ý quan trọng: Vui lòng không tin vào số tài khoản trả nợ do người lạ gửi đến, khoản hoàn trả chỉ có thể được tính khi hoàn trả vào số tài khoản ngân hàng do hệ thống hiển thị, đừng để bị lừa! '
  }
};



// WEBPACK FOOTER //
// ./src/i18/lang/vn.js